import React, { useRef, useState } from 'react';
import './DragAndDrop.css';
import { ReactComponent as UploadIcon } from '../../../assets/img/upload.svg';

const DragAndDrop = ({ onFile, onError }) => {
  const fileInputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFile = (file) => {
    if (!file) return;
    // Add file type validation if needed
    onFile(file);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  return (
    <div className="drag-drop-container">
      <div
        className={`drag-drop-zone${dragActive ? ' drag-active' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={(e) => handleFile(e.target.files[0])}
          accept="application/pdf"
        />
        <p className="drag-drop-text">Drag and drop your files here</p>
        <p className="supported-files">Supported files: PDF</p>
        <button type="button" className="select-files-btn" onClick={triggerFileInput}>
          <div className="select-files-btn-icon">
            <UploadIcon />
            <p>Select files</p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default DragAndDrop;
